export default class User {
    constructor(email = "", first_name = "", last_name = "", profession = "", projects = {}, accessToken="", refreshToken="", last_updated="", sub_plan=0, sub_cancel_pending="") {
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
        this.email = email;
        this.first_name = first_name;
        this.last_name = last_name;
        this.profession = profession;
        this.projects = projects;
        // this.shared_projects = shared_projects;
        this.last_updated = last_updated;
        this.sub_plan = sub_plan;
        this.sub_cancel_pending = sub_cancel_pending;
    }
}
